<template>
  <div class="page_map">
    <van-nav-bar
      title="车辆轨迹详情"
      left-text="返回"
      left-arrow
      @click-left="back"
    />
    <div id="container"></div>
  </div>
</template>

<script>
import startImg from "@/assets/img/map/01.png";
import endImg from "@/assets/img/map/02.png";
import carImg from "@/assets/img/map/car.png";
import axios from "axios";
export default {
  props: ["datas"],
  watch: {
    httpComfirmNumber() {
      if (this.httpComfirmNumber === 3) {
        console.log(this.mapData);
        this.$msg.clear();
        this.loadMap();
      }
    },
    datas() {
      this.mapData = this.datas;
    },
  },
  data() {
    return {
      httpComfirmNumber: 0,
      map: null,
      marker: null,
      mapData: {},
      error: false,
    };
  },
  created() {
    let mapData = this.datas || this.$route.params.mapData;
    if (mapData) {
      this.mapData = mapData;
      console.log("mapData", mapData);
      this.getData();
    } else {
      this.handleError("地图参数异常");
    }
  },
  mounted() {
    this.$msg.loading("查询数据中..");
  },
  destroyed() {
    this.map ? this.map.destroy() : "";
    console.log("销毁地图");
  },
  methods: {
    back() {
      if (this.datas) {
        this.$emit("close");
      } else {
        this.$router.go(-1);
      }
    },
    handleError(text) {
      if (!this.error) {
        this.error = true;
        let that = this;
        setTimeout(() => {
          that.$msg.error(text);
          that.back();
        }, 1000);
      }
    },
    getData() {
      this.httpComfirmNumber = 0;
      axios({
        mathod: "get",
        url: process.env.VUE_APP_DRIVER_API+"/driverElectricFence/getAreaNameByElectricFence",
        params: {
          areaNames: this.mapData.startName,
          buzId: this.mapData.buzId,
        },
        headers: { Token: "Basic c3VwZXItYWRtaW46SHg4U0VjUkdXYUI=" },
      }).then((res) => {
        res = res.data;
        if (res.code === 0 && res.data && res.data.length > 0) {
          this.mapData.startLat = res.data[0].lat;
          this.mapData.startLng = res.data[0].lng;
          this.httpComfirmNumber++;
        } else {
          this.handleError("暂无运输轨迹(0)");
        }
      });
      axios({
        mathod: "get",
        url: process.env.VUE_APP_DRIVER_API+"/driverElectricFence/getAreaNameByElectricFence",
        params: {
          areaNames: this.mapData.endAddr,
          buzId: this.mapData.buzId,
        },
        headers: { Token: "Basic c3VwZXItYWRtaW46SHg4U0VjUkdXYUI=" },
      }).then((res) => {
        res = res.data;
        if (res.code === 0 && res.data && res.data.length > 0) {
          this.mapData.endLat = res.data[0].lat;
          this.mapData.endLng = res.data[0].lng;
          this.httpComfirmNumber++;
        } else {
          this.handleError("暂无运输轨迹(1)");
        }
      });
      axios({
        mathod: "get",
        url: process.env.VUE_APP_DRIVER_API+"/driverTrack/getDriverTrackByBuzIdAndTransportCode",
        params: {
          buzId: this.mapData.buzId,
          source: "02",
          transportCode: this.mapData.transportCode,
        },
        headers: { Token: "Basic c3VwZXItYWRtaW46SHg4U0VjUkdXYUI=" },
      }).then((res) => {
        res = res.data;
        if (res.code === 0 && res.data && res.data.length > 0) {
          this.mapData.roadList = res.data[0].list;
          this.mapData.driverInfo =
            res.data[0].driver + " " + res.data[0].phone;
          this.httpComfirmNumber++;
        } else {
          this.handleError("暂无运输轨迹(2)");
        }
      });
    },
    loadMap() {
      let mapData = this.mapData;
      console.log("mapdata", mapData);
      let startLatLng = new TMap.LatLng(mapData.startLat, mapData.startLng);
      let endLatLng = new TMap.LatLng(mapData.endLat, mapData.endLng);
      let carLat = null;
      let carLng = null;
      let carLatLng = null;
      if (mapData.status < 5 && mapData.roadList.length > 0) {
        carLat = Number(mapData.roadList[0].lat);
        carLng = Number(mapData.roadList[0].lng);
        carLatLng = new TMap.LatLng(carLat, carLng);
      }

      let path = [];
      let errorPath = [];
      console.log("mapData", mapData);
      mapData.roadList.forEach((item) => {
        if (Number(item.lat) > 0 && Number(item.lat) > 0) {
          path.push(new TMap.LatLng(item.lat, item.lng));
        } else {
          errorPath.push(item);
        }
      });
      console.log("errorPath", errorPath);
      //var center = new TMap.LatLng(39.98412, 116.307484);//定义地图中心点坐标
      this.map = new TMap.Map(document.getElementById("container"), {
        showControl: false, //是否显示地图控件
        // center: center, //设置地图中心点坐标
        zoom: 15, //设置地图缩放级别
        //pitch: 40, //设置俯仰角
        //rotation: 45,    //设置地图旋转角度
        baseMap: {
          //底图设置（参数为：VectorBaseMap对象）
          type: "vector", //类型：失量底图
          //features: ["base", "building2d"],
          //仅渲染：道路及底面(base) + 2d建筑物(building2d)，以达到隐藏文字的效果
        },
      });
      let that = this;
      this.marker = new TMap.MultiMarker({
        map: that.map, //指定地图容器

        geometries: [
          {
            id: "car",
            styleId: "car",
            position: carLatLng,
          },
          {
            id: "1", //点标记唯一标识，后续如果有删除、修改位置等操作，都需要此id
            styleId: "start", //指定样式id
            position: startLatLng, //点标记坐标位置
            properties: {
              //自定义属性
              title: "起点",
            },
          },
          {
            //第二个点标记
            id: "2",
            styleId: "end",
            position: endLatLng,
            properties: {
              title: "终点",
            },
          },
        ],
      });
      //设置点标记样式
      this.marker.setStyles({
        car: new TMap.MarkerStyle({
          width: 40, //小车图片宽度（像素）
          height: 40, //高度
          anchor: {
            //图片中心的像素位置（小车会保持车头朝前，会以中心位置进行转向）
            x: 20,
            y: 20,
          },
          //faceTo: "map", //取’map’让小车贴于地面，faceTo取值说明请见下文图示
          rotate: 0, //初始小车朝向（正北0度，逆时针一周为360度，180为正南）
          src: carImg, //小车图片（图中小车车头向上，即正北0度）
        }),
        start: new TMap.MarkerStyle({
          width: 15,
          height: 15,
          src: startImg,
        }),
        end: new TMap.MarkerStyle({
          width: 15,
          height: 15,
          src: endImg,
        }),
      });

      //绘制路线
      var polylineLayer = new TMap.MultiPolyline({
        map: that.map, // 绘制到目标地图
        // 折线样式定义
        styles: {
          style_blue: new TMap.PolylineStyle({
            color: "#3777FF", // 线填充色
            width: 6, // 折线宽度
            borderWidth: 2, // 边线宽度
            borderColor: "#FFF", // 边线颜色
            lineCap: "round", // 线端头方式
            eraseColor: "rgba(190,188,188,1)",
          }),
        },
        geometries: [
          {
            id: "erasePath",
            styleId: "style_blue",
            paths: path,
          },
        ],
      });
      if (mapData.status < 5) {
        //如果不是已完成的订单，显示司机定位信息
        //初始化弧线图并添加至map图层
        let toLat = mapData.status < 3 ? mapData.startLat : mapData.endLat;
        let toLng = mapData.status < 3 ? mapData.startLng : mapData.endLng;
        let arcData = [
          {
            id: "red",
            from: {
              lat: carLat,
              lng: carLng,
            }, // 弧线起点
            to: { lat: Number(toLat), lng: Number(toLng) }, // 弧线终点
          },
        ];
        var arc = new TMap.visualization.Arc({
          pickStyle: function (item) {
            //轨迹图样式映射函数
            return {
              width: 4,
              color: "rgba(0,201,96,0.8)",
              animateColor: "rgba(0,0,255,0.7)",
            };
          },
          enableBloom: false, //泛光
          processAnimation: {
            duration: 1000, //动画时长
            tailFactor: 1, //尾迹比例
          },
          mode: "vertical", // 弧线平面与地平面垂直,
          //curvature:0.6//弧线曲度，取值范围(0, 1]，默认为0.6。
        })
          .addTo(this.map)
          .setData(arcData); //设置数据

        this.map.on("zoom", function () {
          console.log("zoom：", that.map.getZoom());
        });

        //初始化辐射圈
        var radiationCircle_0 = new TMap.visualization.Radiation({
          styles: {
            default: {
              fillColor: "rgba(0,0,0,0)", // 辐射圈填充颜色
              strokeColor: "rgba(0,201,96,1)", // 辐射圈边线颜色
              strokeWidth: 10, //	区域边线宽度
            },
          },
          //maxZoom:17,
          minZoom: 16.5,
          number: 1, // 每一时刻，辐射圈的同心圆个数
        })
          .addTo(this.map)
          .setData([
            {
              center: carLatLng,
              radius: 50,
            },
          ]);
        var radiationCircle0 = new TMap.visualization.Radiation({
          styles: {
            default: {
              fillColor: "rgba(0,201,96,1)", // 辐射圈填充颜色
              // strokeColor: "rgba(0,201,96,1)", // 辐射圈边线颜色
              // strokeWidth: 30, //	区域边线宽度
            },
          },
          maxZoom: 16.5,
          minZoom: 14.7,
          number: 2, // 每一时刻，辐射圈的同心圆个数
        })
          .addTo(this.map)
          .setData([
            {
              center: carLatLng,
              radius: 200,
            },
          ]);
        var radiationCircle1 = new TMap.visualization.Radiation({
          styles: {
            default: {
              fillColor: "rgba(0,201,96,1)",
            },
          },
          maxZoom: 14.7,
          minZoom: 12.5,
          number: 2,
        })
          .addTo(this.map)
          .setData([
            {
              center: carLatLng,
              radius: 800,
            },
          ]);
        var radiationCircle2 = new TMap.visualization.Radiation({
          styles: {
            default: {
              fillColor: "rgba(0,201,96,1)",
            },
          },
          maxZoom: 12.5,
          minZoom: 10.5,
          number: 2,
        })
          .addTo(this.map)
          .setData([
            {
              center: carLatLng,
              radius: 3000,
            },
          ]);
        var radiationCircle3 = new TMap.visualization.Radiation({
          styles: {
            default: {
              fillColor: "rgba(0,201,96,1)",
            },
          },
          maxZoom: 10.5,
          minZoom: 9,
          number: 2,
        })
          .addTo(this.map)
          .setData([
            {
              center: carLatLng,
              radius: 9000,
            },
          ]);
        var radiationCircle4 = new TMap.visualization.Radiation({
          styles: {
            default: {
              fillColor: "rgba(0,201,96,1)",
            },
          },
          maxZoom: 9,
          minZoom: 7.5,
          number: 2,
        })
          .addTo(this.map)
          .setData([
            {
              center: carLatLng,
              radius: 30000,
            },
          ]);
        var radiationCircle5 = new TMap.visualization.Radiation({
          styles: {
            default: {
              fillColor: "rgba(0,201,96,1)",
            },
          },
          maxZoom: 7.5,
          number: 2,
        })
          .addTo(this.map)
          .setData([
            {
              center: carLatLng,
              radius: 100000,
            },
          ]);
      }

      //创建移动的小车
      //   this.marker.moveAlong(
      //     {
      //       car: {
      //         //设置让"car"沿"path"移动，速度70公里/小时
      //         path,
      //         speed: 300,
      //       },
      //     },
      //     {
      //       autoRotation: true, //车头始终向前（沿路线自动旋转）
      //     }
      //   );
      //创建InfoWindow实例，并进行初始化
      let content1 =
        `
    <div class="info_card">
        <div class="title red">起点：` +
        mapData.startName +
        `</div>
        <div align="left" class="content">司机信息：` +
        mapData.driverInfo +
        `</div>
        <span class="cancle bot"></span>
    </div>`;
      let infowindow1 = new TMap.InfoWindow({
        enableCustom: true,
        content: content1, //信息窗口内容
        position: startLatLng, //显示信息窗口的坐标
        map: this.map,
        offset: { x: 0, y: -28 }, //设置信息窗相对position偏移像素，为了使其显示在Marker的上方
      });
      let content2 =
        `
    <div class="info_card">
        <div class="title green">终点：` +
        mapData.endName +
        `</div>
        <div align="left" class="content">` +
        mapData.endAddr +
        `</div>
        <span class="cancle bot"></span>
    </div>`;
      let infowindow2 = new TMap.InfoWindow({
        enableCustom: true,
        content: content2, //信息窗口内容
        position: endLatLng, //显示信息窗口的坐标
        map: this.map,
        offset: { x: 0, y: -28 }, //设置信息窗相对position偏移像素，为了使其显示在Marker的上方
      });

      //自适应显示全部点标记
      var coords = [startLatLng, endLatLng, carLatLng];
      //创建LatLngBounds实例
      var latlngBounds = new TMap.LatLngBounds();
      //将坐标逐一做为参数传入extend方法，latlngBounds会根据传入坐标自动扩展生成
      for (var i = 0; i < coords.length; i++) {
        latlngBounds.extend(coords[i]);
      }
      //调用fitBounds自动调整地图显示范围
      this.map.fitBounds(latlngBounds, { padding: 120 });
      //路线集合
    },
  },
};
</script>

<style lang="scss">
.page_map {
  width: 100vw;
  height: 100vh;
  #container {
    width: 100%;
    height: calc(100% - 46px);

    .info_card {
      display: inline-block;
      box-shadow: 0 0 24px rgba(0, 0, 0, 0.3);
      background-color: #fff;
      font-size: 14px;
      max-width: 80vw;
      .title {
        width: 100%;
        padding: 5px;
        text-align: center;
        color: #ffffff;
        &.green {
          background-color: #00c960;
        }
        &.red {
          background-color: #ff5454;
        }
      }
      .content {
        height: 40px;
        line-height: 40px;
        padding: 0 5px;
        overflow: hidden;
        white-space: nowrap;
        text-overflow: ellipsis;
      }
      .cancle {
        width: 0;
        height: 0;
        font-size: 0;
        overflow: hidden;
        position: absolute;
        &.bot {
          border-width: 20px;
          border-style: solid dashed dashed;
          border-color: #ffffff transparent transparent;
          left: calc(50% - 20px);
          bottom: -39px;
        }
      }
    }
  }
}
</style>
